module.exports = __webpack_public_path__ + "static/logo-4d31bc5eb8bd713d3e0161fe9cec8c86.png";